import { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "sw_admin_token";

const AdminAuthContext = createContext(null);

export const AdminAuthProvider = ({ children }) => {
  const [token, setToken] = useState(() => localStorage.getItem(TOKEN_KEY));
  const [checking, setChecking] = useState(!!localStorage.getItem(TOKEN_KEY));
  const [authed, setAuthed] = useState(false);

  const verify = useCallback(async (t) => {
    if (!t) {
      setAuthed(false);
      setChecking(false);
      return false;
    }
    try {
      await axios.get(`${API}/admin/me`, { headers: { Authorization: `Bearer ${t}` } });
      setAuthed(true);
      setChecking(false);
      return true;
    } catch (e) {
      localStorage.removeItem(TOKEN_KEY);
      setToken(null);
      setAuthed(false);
      setChecking(false);
      return false;
    }
  }, []);

  useEffect(() => {
    verify(token);
  }, [token, verify]);

  const login = async (password) => {
    const { data } = await axios.post(`${API}/admin/login`, { password });
    localStorage.setItem(TOKEN_KEY, data.access_token);
    setToken(data.access_token);
    setAuthed(true);
    return true;
  };

  const logout = () => {
    localStorage.removeItem(TOKEN_KEY);
    setToken(null);
    setAuthed(false);
  };

  const authHeader = () => (token ? { Authorization: `Bearer ${token}` } : {});

  return (
    <AdminAuthContext.Provider value={{ token, authed, checking, login, logout, authHeader }}>
      {children}
    </AdminAuthContext.Provider>
  );
};

export const useAdminAuth = () => {
  const ctx = useContext(AdminAuthContext);
  if (!ctx) throw new Error("useAdminAuth must be used within AdminAuthProvider");
  return ctx;
};
